//基础store
import {VuexStore} from '@/core/storage'
import lodash from 'lodash'

function initUserInfo(userInfo) {
    if (userInfo == null)
        userInfo = VuexStore.getValue('userInfo');

    if (userInfo != null && userInfo.permCodeList != null && Array.isArray(userInfo.permCodeList)) {
        userInfo.permCodeSet = new Set(userInfo.permCodeList);
    }

    return userInfo;
}
const globalStore = {
    state: {
        // 是否左侧菜单折叠
        isCollapse: false,
        // 浏览器客户区高度
        documentClientHeight: 100,
        // 是否正在进行http请求
        isHttpLoading: false,
        // 用户登录信息
        userInfo: initUserInfo(),
        // 缓存页面
        cachePages: VuexStore.getValue('cachePages') || []
    },
    mutations: {
        setCollapse: (state, isCollapse) => {
            state.isCollapse = isCollapse;
        },
        setClientHeight: (state, height) => {
            state.documentClientHeight = height;
        },
        setInputParams: (state, params) => {
            state.inputParams = lodash.merge(state.inputParams, params);
            VuexStore.storageValue('inputParams', state.inputParams);
        },
        updateInputParams: (state, params) => {
            let key = params.key;
            let value = params.value;
            if (state.inputParams[key] == null) {
                state.inputParams[key] = value;
            }
            else {
                state.inputParams[key] = lodash.merge(state.inputParams[key], value);
            }

            VuexStore.storageValue('inputParams', state.inputParams);
        },
        setLoadingStatus: (state, isLoading) => {
            state.isHttpLoading = isLoading;
        },
        setUserInfo: (state, info) => {
            VuexStore.storageValue('userInfo', info);
            state.userInfo = initUserInfo(info);
        },
        addCachePage (state, name) {
            if (state.cachePages.indexOf(name) === -1) {
                let temp = [...state.cachePages];
                temp.push(name);
                VuexStore.storageValue('cachePages', temp);
                state.cachePages = temp;
            }
        },
        removeCachePage (state, name) {
            let pos = state.cachePages.indexOf(name);
            if (pos !== -1) {
                let temp = [...state.cachePages];
                temp.splice(pos, 1);
                VuexStore.storageValue('cachePages', temp);
                state.cachePages = temp;
            }
        },
        clearCachePage (state) {
            VuexStore.storageValue('cachePages', []);
            state.cachePages = [];
        }
    },
    getters: {
        getCollapse: (state) => {
            return state.isCollapse;
        },
        getClientHeight: (state) => {
            return state.documentClientHeight;
        },
        getInputParams: (state, key) => {
            if (key != null && lodash.isString(key)) {
                return state.inputParams[key];
            }
            else {
                return state.inputParams;
            }
        },
        getLoadingStatus: (state) => {
            return state.isHttpLoading;
        },
        getUserInfo: (state) => {
            return state.userInfo;
        },
        getCachePages: (state) => {
            return state.cachePages;
        }
    },
    actions: {

    }
}

export default {
    state: globalStore.state,
    mutations: globalStore.mutations,
    getters: globalStore.getters,
    actions: globalStore.actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/baseStore.js